import { call, put, takeLatest } from "redux-saga/effects";

import {
  FETCH_BENCHMARK_GENERATION_STATUS_REQUEST,
  fetchBenchmarkGenerationStatusSuccess,
  fetchBenchmarkGenerationStatusFailure,
} from "../actions/benchmarkGenerationStatusActions";

import { getBenchmarkGenerationStatus } from "../../../services/accIqService";

function* handleFetchBenchmarkGenerationStatus(action) {
  try {
    const response = yield call(getBenchmarkGenerationStatus, action.payload);

    yield put(fetchBenchmarkGenerationStatusSuccess(response));
  } catch (error) {
    yield put(
      fetchBenchmarkGenerationStatusFailure(
        error?.response?.data || error.message
      )
    );
  }
}

export default function* benchmarkGenerationStatusSaga() {
  yield takeLatest(
    FETCH_BENCHMARK_GENERATION_STATUS_REQUEST,
    handleFetchBenchmarkGenerationStatus
  );
}
